"use client";

import React from "react";
import { ArrowRight, Sparkles, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const stats = [{
    label: "ZICHTBAARHEID",
    value: "+150%"
  }, {
    label: "TIJDSWINST",
    value: "10u +"
  }, {
    label: "GROEI",
    value: "2.4x"
  }];
  return <section data-section-id="225385" id="humanfactorinaiworld" className="relative min-h-screen w-full bg-[#FFF9F6] flex items-center overflow-hidden selection:bg-[#E67E5D]/20 selection:text-[#1A1A1A]">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-15%] right-[-10%] w-[60vw] h-[60vw] bg-[#E67E5D]/5 rounded-lg blur-[140px]" />
        <div className="absolute inset-0 bg-[radial-gradient(#1A1A1A05_1px,transparent_1px)] [background-size:32px_32px] opacity-50" />
      </div>

      <div ref={contentRef} className={`container mx-auto px-6 relative z-10 transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="flex flex-col items-start text-left max-w-2xl">
            <Badge variant="outline" className="rounded-lg border-[#1A1A1A]/10 text-[#1A1A1A]/80 font-default text-xs tracking-[0.4em] uppercase px-6 py-2.5 bg-white/50 backdrop-blur-sm mb-8 shadow-sm">
              <Sparkles className="w-3.5 h-3.5 mr-2 text-[#E67E5D]" />
              The Human Marketing Factor
            </Badge>

            <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] font-default font-bold tracking-tighter text-[#1A1A1A] mb-8">
              Jouw onderneming verdient een sterk online <span className="!text-[hsl(250,75%,67%)]">podium.</span>
            </h1>

            <p className="text-lg md:text-xl text-[#1A1A1A]/80 mb-10 leading-[1.8] font-light max-w-xl">Ben je ambitieus en zie je groei mogelijkheden voor je onderneming, maar ontbreekt het nog aan een sterk online podium?&nbsp; Wij zijn er om jouw zichtbaarheid en groei te maximaliseren.</p>

            <div className="flex flex-col items-start gap-8">
              <Button asChild size="lg" className="rounded-lg bg-[#1A1A1A] text-white hover:bg-[#1A1A1A]/90 shadow-lg h-14 px-10 text-base tracking-widest font-default uppercase group transition-all duration-500">
                <Link to="/diensten">
                  Bekijk onze aanpak
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1.5 transition-transform duration-300" />
                </Link>
              </Button>

              <div className="w-full h-px bg-[#1A1A1A]/10 my-2" />

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-4">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[hsl(250,75%,67%)] text-[hsl(250,75%,67%)]" />)}
                </div>
                <p className="text-sm font-mono text-[#1A1A1A]/60">
                  onze klanten geven ons gemiddeld 5 sterren.
                </p>
              </div>
            </div>

            
          </div>

          {}
          <div className="relative lg:h-[80vh] w-full">
            <div className="relative h-full w-full overflow-hidden rounded-tl-xl shadow-xl">
              <img src="https://connectedonline.nl/wp-content/uploads/2026/05/byjasminfotografie-173-scaled.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/hero_human_connection.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/hero_human_connection.png-wvc-sizes" alt="Human connection in a digital world" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000" loading="lazy" />
            </div>
            {}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#E67E5D]/10 rounded-lg -z-10" />
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#E67E5D]/10 rounded-lg -z-10" />
            <div className="absolute -bottom-10 -left-10 w-24 h-24 bg-[#E67E5D]/5 rounded-lg -z-20" />
            <div className="absolute -bottom-14 -left-14 w-24 h-24 bg-[#E67E5D]/5 rounded-lg -z-30" />
          </div>
        </div>
      </div>
    </section>;
}